module.exports = __webpack_public_path__ + "img/hotel-da-praia-do-sol-costa-da-caparica.76b660ae.jpg";